export const APP_SIDEBAR_STORAGE_KEY = 'web:sidebar:mode';
